import type { DemoTourStep } from '../types';

export const openingAct: DemoTourStep[] = [
  {
    id: 'opening-professional-pressure',
    act: '一个人',
    eyebrow: 'Act 1',
    route: '/my-agent',
    search: '?panel=inbox',
    fullscreen: true,
    title: '另一个你，已经开始工作',
    description:
      '不是你在使用 Agent，而是你在养成另一个会工作的自己。先从一个专业人士的一天开始。',
    nextLabel: '进入她的一天',
    voiceover: '专业工作里，最累的，从来不是忙。而是你每天都要从零开始。',
    visualDirection:
      '清晨、通勤、未读消息和未完成文档并置，先让观众进入专业人士熟悉的压力感。',
  },
];
